import React from "react";
import { Form, Input, Row, Col, Select, Button, Spin } from "antd";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Endpoints from "../../api/endpoints.js";
import EndpointFunctions from "../../utils/Functions/endpointFunctions.js";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import { useState } from "react";
import { useEffect } from "react";
import DropdownMenus from "../../utils/Constants/dropdownMenus";

const osOptions = [
  {
    label: "Android",
    value: "Android",
  },
  {
    label: "iOS",
    value: "iOS",
  },
];

const ApplicationStatusForm = ({ form, onFinish, initialValues }) => {
  const [appOptions, setAppOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    fetchAppOptions();
  }, []);

  useEffect(() => {
    if (initialValues != null) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues]);

  const fetchAppOptions = async () => {
    setIsLoading(true);
    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getAllApps,
      axiosPrivate: axiosPrivate,
    });
    if (result.success) {
      const appOption = result.data.map((item) => {
        return { value: item.name, label: item.description };
      });
      setAppOptions(appOption);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Form.Item name="minVersion" label="Minimum Versiyon:">
              <Input placeholder="Minimum Versiyon" />
            </Form.Item>
          </Col>
          <Col style={{ flex: 1 }}>
            <Form.Item name="maxVersion" label="Maksimum Versiyon:">
              <Input placeholder="Maksimum Versiyon" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Form.Item name="os" label="İşletim Sistemi:">
              <Select options={osOptions} placeholder="İşletim Sistemi" />
            </Form.Item>
          </Col>
          <Col style={{ flex: 1 }}>
            <Form.Item name="forceUpdate" label="Zorunlu Güncelleme:">
              <Select
                placeholder="Zorunlu Güncelleme"
                style={{ width: "100%" }}
                allowClear
                options={DropdownMenus.trueFalseMenu}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Form.Item name="recommendUpdate" label="Güncelleme Önerisi:">
              <Select
                placeholder="Güncelleme Önerisi"
                style={{ width: "100%" }}
                allowClear
                options={DropdownMenus.trueFalseMenu}
              />
            </Form.Item>
          </Col>
          <Col style={{ flex: 1 }}>
            <Form.Item name="maintenanceMode" label="Bakım Modu:">
              <Select
                placeholder="Bakım Modu"
                style={{ width: "100%" }}
                allowClear
                options={DropdownMenus.trueFalseMenu}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Spin spinning={isLoading}>
              <Form.Item name="app" label="Uygulama:">
                <Select options={appOptions} placeholder="Uygulama" />
              </Form.Item>
            </Spin>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: 8, width: "25%" }}>
            Gönder
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ApplicationStatusForm;
